/* Unik — product-card and product-page image galleries.
   Arrows, tick indicators, "n / total" counter, wrapping both ways.
   Each slide can carry its own model bar (data-model) and focal point. */
(function () {
  function show(gal, i) {
    var slides = gal.querySelectorAll('[data-slide]');
    if (!slides.length) return;
    var n = slides.length;
    var idx = ((i % n) + n) % n;

    slides.forEach(function (s, k) { s.hidden = k !== idx; });

    var dots = gal.querySelectorAll('[data-dot]');
    dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });

    var counter = gal.querySelector('[data-counter]');
    if (counter) counter.textContent = (idx + 1) + ' / ' + n;

    var bar = gal.querySelector('[data-model-bar]');
    var model = slides[idx].getAttribute('data-model') || '';
    if (bar) {
      bar.textContent = model;
      bar.hidden = model === '';
    }
    gal.classList.toggle('has-model', model !== '');

    gal.dataset.index = idx;
  }

  function step(gal, delta) {
    show(gal, Number(gal.dataset.index || 0) + delta);
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-gal-step]');
    if (arrow) {
      e.preventDefault();
      var gal = arrow.closest('[data-gallery]');
      if (gal) step(gal, Number(arrow.dataset.galStep));
      return;
    }

    var dot = e.target.closest('[data-dot]');
    if (dot) {
      e.preventDefault();
      var g = dot.closest('[data-gallery]');
      if (g) show(g, Number(dot.dataset.dot));
      return;
    }

    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      e.preventDefault();
      var pdp = thumb.closest('[data-gallery]');
      if (pdp) {
        show(pdp, Number(thumb.dataset.thumb));
        pdp.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
        });
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) { show(gal, 0); });
  });
})();
